import { GET_ZONAS_CENTRO, MODIFY_ZONA_CENTRO, ADD_ZONA_CENTRO, REMOVE_ZONA_CENTRO } from '../constants/action_types';

const initialState = {
    isLoading: false,
    zonas: [],
    centroId: -1
};

export default function (state = initialState, action) {

    switch (action.type) {
        case GET_ZONAS_CENTRO:

            return {...state, isLoading: true, centroId: action.meta}

        case GET_ZONAS_CENTRO + "_SUCCESS":

            return {
                ...state,
                isLoading: false,
                zonas: action.payload.data
            };

        case MODIFY_ZONA_CENTRO:

            return {
                ...state,
                isLoading: false,
                zonas: state.zonas.map((zona) => {
                    if (zona.id !== action.payload.id) return zona;
                    else return action.payload;
                })
            };

        case ADD_ZONA_CENTRO:

            const newArr = [...state.zonas, action.payload];
            return {
                ...state,
                isLoading: false,
                zonas: newArr
            };;

        case REMOVE_ZONA_CENTRO:

            return {
                ...state,
                isLoading: false,
                zonas: state.zonas.filter(zona => zona.id !== action.payload.id)
            };

        default:

            return state;
    }
}